"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration = (sdk) => {
    const { sdkConfig: { url }, defaultVersion } = sdk;
    const httpClient = sdk.httpClient;
    return {
        getUpgradeCode: async (code) => {
            const endpoint = `${url}/${defaultVersion}/configurations/codesToLicenceMapping/typeMapping`;
            const result = await httpClient.get(endpoint, {
                auth: false,
                query: {
                    mappingKey: code
                }
            });
            return result.data;
        }
    };
};
exports.default = configuration;
